<template>
  <div v-if="summary" class="flex flex-col gap-16" :class="attrs.class">
    <div
      class="flex flex-col items-start justify-start md:flex-row md:items-start md:justify-between md:gap-16"
    >
      <div class="heading-2">
        {{ i18n(translations.title, { productName }) }}
      </div>
      <span class="caption shrink-0 md:my-6"
        >{{ i18n(translations.caption) }} <IconInfo class="inline" size="16"
      /></span>
    </div>

    <p class="body-1 text-justify">
      {{ summary }}
    </p>
  </div>

  <RevSkeleton
    v-else-if="pending"
    :class="attrs.class"
    height="100px"
    shape="rectangle"
    width="100%"
  />
</template>

<script lang="ts" setup>
import { useAttrs } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkeleton } from '@ds/components/Skeleton'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './AISummary.translations'

const i18n = useI18n()

const attrs = useAttrs()

defineProps<{
  productName: string
  summary: string | undefined
  pending: boolean
}>()
</script>
